import { useFm } from '@web3/base-hooks';
import Modal from '../Modal';
import { WalletTypeTextKey } from '@/config/common';
import { useMemo } from 'react';
import { WalletType } from '@web3/base-utils';
import { SwitchWalletButton } from '../SwitchWalletButton';

type ISwitchWallet = {
  visible: boolean;
  walletTypeList: WalletType[];
  handleCancel: () => void;
};

export function SwitchWallet(props: ISwitchWallet) {
  const { visible, walletTypeList } = props;
  const fm = useFm();
  const walletListText = useMemo(() => {
    const textArr: any[] = [];
    walletTypeList?.forEach((item) => {
      item !== WalletType.PRIVATE_KEY &&
        textArr.push(fm(WalletTypeTextKey[item]));
    });
    return textArr.join(',');
  }, [walletTypeList]);

  return (
    <Modal
      visible={visible}
      type={'alert'}
      size={'small'}
      title=""
      cancelText={false}
      onCancel={props.handleCancel}
      footer={
        <div className="flex justify-center">
          <SwitchWalletButton
            type="button"
            walletTypeList={walletTypeList}
            onOk={() => {
              props.handleCancel();
            }}
          />
        </div>
      }
    >
      <div className="text-center">
        <h3 className="text-lg font-semibold">{fm('pleaseSwitchWallet')}</h3>
        <p className="mt-2 text-gray1">
          {fm('walletTypeSwitchTip', {
            walletType: walletListText,
          })}
        </p>
      </div>
    </Modal>
  );
}
